import * as React from 'react'
import RouteWrapper from 'components/HOC/RouteWrapper/index'
import { routeMap } from 'constants/routes'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import { Select, Spin, Table, Row, Col, Button } from 'antd'
import { debounce, throttle } from 'lodash'
import { checkStatus } from 'constants/index'
import { inject, observer } from 'mobx-react'
const Option = Select.Option
import { get as _get } from 'lodash'
import { levelStrategies } from 'store/LevelStore'

import checkedIcon from 'assets/checked-empty.svg'
import timeoutActiveIcon from 'assets/timeout-active-icon.svg'
import infoIcon from 'assets/info-icon.svg'
import { string } from 'prop-types'

const PER_PAGE = 100
const StatusCircle = (props: any) => {
  const { status, check, onClick, grade } = props

  const statusCircleStyle = {
    [checkStatus.todo]: {
      border: '2px solid #979797',
      borderRadius: '50%',
    },
    [checkStatus.doing]: {
      border: '2px solid #979797',
      borderRadius: '50%',
    },
    [checkStatus.done]: {
      backgroundImage: `url(${
        check.important === '是' ? infoIcon : checkedIcon
      })`,
    },
    [checkStatus.timeout]: {
      backgroundImage: `url(${timeoutActiveIcon})`,
    },
    [checkStatus.discard]: {
      backgroundImage: `url(${timeoutActiveIcon})`,
    },
  }

  return (
    <div>
      <div
        className={styles.statusCircle}
        onClick={onClick}
        style={{
          ...statusCircleStyle[status],
        }}
      >
        {(status === checkStatus.todo || status === checkStatus.doing) && grade}
      </div>
      <p>{check.name}</p>
    </div>
  )
}

interface StaffPassStatusProps {
  globalStore?: any
  levelStore?: any
}

interface StaffPassStatusState {
  fetching: boolean
  currentOpt: string | number
  lessons: any[]
  currentLessonId: number
  staffChecks: any[]
  staffChecksMeta: object | any
  examList: any[]
  passStatus: any // 各个员工的当前激活态下的关卡通关情况
  answers: any // 各个员工的当前激活态下的关卡的综合题信息
  filterOption: any
  currentStatus: string
  currentStaffId: string
  currentPage: number
  usersMeta: any
  users: any[]
  role_id: number | string
}

@inject('globalStore', 'levelStore')
@observer
class StaffPassStatus extends ComponentExt<
  StaffPassStatusProps,
  StaffPassStatusState
> {
  state = {
    fetching: false,
    lessons: [],
    currentOpt: 0,
    currentLessonId: 0,
    staffChecks: [],
    staffChecksMeta: null,
    examList: [],
    passStatus: {},
    answers: {},
    filterOption: {},
    currentStatus: checkStatus.doing,
    currentStaffId: '',
    currentPage: 1,
    usersMeta: null,
    users: [],
    role_id: '',
  }

  constructor(props) {
    super(props)
    this.onStaffSearch = debounce(this.onStaffSearch, 800)
    this.onStaffScroll = throttle(this.onStaffScroll, 300, { trailing: false })
  }

  async componentDidMount() {
    await this.fetchLessons()
    this.fetchStaff({})
    this.getUserStaffChecks(this.filterOption)
    this.getCheckRoles({
      lesson_id: this.state.currentLessonId,
      per_page: PER_PAGE,
    })
  }

  fetchLessons = async (params?: object): Promise<any> => {
    const lessons = await this.api.level.getLessons(params)

    this.setState({ lessons, currentLessonId: lessons[0].id })
  }

  onStaffSearch = (keyword: string): void => {
    this.fetchStaff({ keyword })
  }

  fetchStaff = async (param: any, mode = 'add'): Promise<any> => {
    this.setState({
      fetching: true,
    })
    const res = await this.api.user.getUserStaff(param)

    this.setState({
      fetching: false,
      users: mode === 'add' ? res.data : this.state.users.concat(res.data),
      usersMeta: res.meta.pagination,
    })
  }

  getUserStaffChecks = async (params?: any): Promise<any> => {
    const checks = await this.api.level.getUserStaffChecks(params)

    this.setState({
      staffChecks: checks.data,
      staffChecksMeta: checks.meta,
    })
  }

  getCheckRoles = param => {
    const {
      levelStore: { getEntityList },
    } = this.props
    getEntityList(levelStrategies.CHECK_ROLES, param)
  }

  get filterOption() {
    const {
      currentLessonId,
      currentStatus,
      currentStaffId,
      role_id,
    } = this.state

    return {
      lesson_id: currentLessonId,
      status: currentStatus,
      staff_id: currentStaffId,
      per_page: 5,
      page: 1,
      role_id,
    }
  }

  onStaffChange = (value: any): void => {
    this.setState({
      fetching: false,
    })
  }

  choseStaff = async (value: string): Promise<any> => {
    this.setState(
      {
        currentStaffId: value,
        currentPage: 1,
      },
      () => {
        this.getUserStaffChecks(this.filterOption)
      },
    )
  }

  onStaffScroll = async e => {
    const isBottom = e.target
      ? e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) <=
        60
      : false
    const { usersMeta, users } = this.state

    if (isBottom && usersMeta.total > users.length) {
      await this.fetchStaff({ page: usersMeta.current_page + 1 }, 'append')
    }
  }

  choseLesson = async (params: any): Promise<any> => {
    this.setState(
      {
        currentLessonId: params.lesson_id,
        currentStaffId: '',
        currentPage: 1,
      },
      () => {
        this.getUserStaffChecks(this.filterOption)
      },
    )
  }

  choseCheckStatus = val => {
    this.setState(
      {
        currentStatus: val,
        currentPage: 1,
      },
      () => {
        this.getUserStaffChecks(this.filterOption)
      },
    )
  }

  getRequiredCheckInfo = async (check: any, recordId: number): Promise<any> => {
    const taskIds = _get(check, 'check_task_records').map(task => task.id)
    const answersData = await Promise.all(
      taskIds.map(id => {
        return this.api.level.getCheckTaskRecordAnswer(id)
      }),
    )

    const answers = []
    const reg = /<\/?.+?\/?>/g

    answersData.forEach((item: any) => {
      if (item.length > 0) {
        item.forEach(element => {
          if (reg.test(element.content)) {
            element.content = element.content.replace(reg, '')
          }
          answers.push(element)
        })
      }
    })

    this.setState({
      passStatus: {
        ...this.state.passStatus,
        [recordId]: check.status,
      },
      answers: {
        ...this.state.answers,
        [recordId]: answers,
      },
    })
  }

  onCheckRolesChange = val => {
    this.setState({ role_id: val }, () =>
      this.getUserStaffChecks(this.filterOption),
    )
  }

  render() {
    const {
      fetching,
      users,
      lessons,
      currentLessonId,
      currentStaffId,
      staffChecks,
      staffChecksMeta,
      passStatus,
      answers,
      currentPage,
      currentStatus,
      role_id,
    } = this.state
    const {
      globalStore: { staffInfo },
      levelStore: { checkRoles },
    } = this.props

    const { staff_name, staff_level, entity } = staffInfo
    const opts = users.map(user => (
      <Option key={user.staff_id} value={user.staff_id}>
        {user.staff_name}
      </Option>
    ))
    const columns: any = [
      {
        title: '员工姓名',
        key: 'name',
        width: 95,
        align: 'center',
        render: (text, record) => record.staff.staff_name,
      },
      {
        title: (text, record) => {
          return <div style={{ display: 'block' }}>通关情况（关卡序号）</div>
        },
        className: 'check-status',
        key: 'status',
        width: 478,
        align: 'center',
        render: (text, record) => {
          return (
            <div
              style={{
                maxHeight: 250,
                overflowY:
                  record.check_records.length > 20 ? 'scroll' : 'unset',
              }}
            >
              {record.check_records.map(check => (
                <div key={check.id} className={styles.checkStatusItem}>
                  <StatusCircle
                    {...check}
                    onClick={this.getRequiredCheckInfo.bind(
                      this,
                      check,
                      record.id,
                    )}
                  />
                </div>
              ))}
            </div>
          )
        },
      },
      {
        title: () => <div style={{ textAlign: 'center' }}>备注</div>,
        key: 'remark',
        align: 'left',
        render: (text, record) => {
          const answer = answers[record.id]
          return (
            <div className={styles.remark}>
              <p className={styles.remarkTitle}>
                <strong>{passStatus[record.id]}</strong>
              </p>
              <div style={{ maxHeight: 250, overflowY: 'scroll' }}>
                {record.status === checkStatus.timeout ? (
                  <p className={styles.remarkTimeout}>
                    该关卡已超时，请联系员工了解超时情况；
                  </p>
                ) : (
                  answer &&
                  answer.map((item, index) => (
                    <div className={styles.answer} key={item.id}>
                      <p>{`${index + 1}、${item.type}题：${item.content}`}</p>
                      <p>{`解答：`}</p>
                      <p>{item.examinee_answers[0]}</p>
                    </div>
                  ))
                )}
              </div>
            </div>
          )
        },
      },
    ]

    const tablePagination = {
      current: currentPage,
      pageSize: 5,
      total: staffChecksMeta && _get(staffChecksMeta, 'pagination.total'),
      onChange: (page, pageSize) => {
        this.setState({ currentPage: page })
        this.getUserStaffChecks({
          ...this.filterOption,
          per_page: pageSize,
          page,
        })
      },
    }

    const checkStatusFilter = [checkStatus.doing, checkStatus.done]

    return (
      <div className={styles.staffPassStatus}>
        <section className={styles.header}>
          <div className={styles.headerTitle}>
            <h2 className={styles.headerTitle}>员工通关情况</h2>
            <Select
              showSearch
              notFoundContent={fetching ? <Spin size="small" /> : null}
              style={{ width: 200 }}
              placeholder="选择员工"
              value={currentStaffId}
              onSearch={this.onStaffSearch}
              onChange={this.onStaffChange}
              onSelect={this.choseStaff}
              onPopupScroll={this.onStaffScroll}
              optionFilterProp="children"
            >
              <Option key={'-1'} value={''}>
                全部
              </Option>
              {opts}
            </Select>
          </div>

          <p className={styles.headerInfo}>
            <span>单位：{entity && entity.entity_name} </span>
            <span>姓名：{staff_name} </span>
            <span>身份：{staff_level} </span>
          </p>
          <div className={styles.headerLessons}>
            <Row>
              <Col span={24}>
                {lessons.map(lesson => (
                  <a
                    target="javascript:;"
                    className={`${styles.headerLessonBtn} ${
                      lesson.id === currentLessonId
                        ? styles.headerLessonActiveBtn
                        : ''
                    }`}
                    key={lesson.id}
                    onClick={this.choseLesson.bind(this, {
                      lesson_id: lesson.id,
                    })}
                  >
                    {lesson.name}
                  </a>
                ))}
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={12}>
                <Select
                  defaultValue={''}
                  onChange={null}
                  value={role_id}
                  style={{ minWidth: 235 }}
                  onSelect={this.onCheckRolesChange}
                  placeholder={'请选择配置关卡角色'}
                >
                  <Option key={-1} value={''}>
                    无
                  </Option>
                  {checkRoles.map(role => (
                    <Option key={role.id} value={role.id}>
                      {role.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                {checkStatusFilter.map((filter, index) => {
                  const activeStyle =
                    currentStatus === filter
                      ? {
                          color: '#ff715e',
                          backgroundColor: '#fff',
                          borderColor: '#ff715e',
                        }
                      : {}
                  return (
                    <Button
                      key={index}
                      style={{ ...activeStyle, marginLeft: 10 }}
                      onClick={this.choseCheckStatus.bind(this, filter)}
                    >
                      {filter}
                    </Button>
                  )
                })}
              </Col>
            </Row>
          </div>
        </section>
        <section className={styles.content}>
          <Table
            rowKey={'id'}
            bordered
            columns={columns}
            pagination={tablePagination}
            dataSource={staffChecks}
          />
        </section>
      </div>
    )
  }
}

export default RouteWrapper(routeMap.LEVEL_UP.PASS_STATUS.path)(StaffPassStatus)
